import { RecordOf } from '@opengov/compose-app/immutable';

export type TClaims = {
  REPORTING_ADMIN_CLAIM: boolean,
  REPORTING_ENTITLEMENT: boolean,
  REPORTING_MANAGER_PRIVILEGE: boolean,
  REPORTING_DASHBOARD_READ_ALL: boolean,
}

export interface IFetchClaimsSuccess {
  claims: TClaims;
  entityUuid: string;
}

export const RequestStatus = RecordOf<IRequestStatus>({ status: 'pending', error: null });

export interface IRequestStatus {
  status: 'pending' | 'success' | 'error';
  error?: Error;
}

